export enum BusinessRcCompanyCoverageValidity {
  ONE_YEAR = 'ONE_YEAR',
  THREE_YEARS = 'THREE_YEARS',
  FIVE_YEARS = 'FIVE_YEARS',
}

export const getBusinessRcCompanyCoverageValidityLabel = (
  cover: BusinessRcCompanyCoverageValidity
) => {
  switch (cover) {
    case BusinessRcCompanyCoverageValidity.ONE_YEAR:
      return $localize`1 an`;
    case BusinessRcCompanyCoverageValidity.THREE_YEARS:
      return $localize`3 ans`;
    case BusinessRcCompanyCoverageValidity.FIVE_YEARS:
      return $localize`5 ans`;
    default:
      return '';
  }
};
